import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    ConfigContext,
    EnhancedTable
} from '../../lib';
import { useContext } from 'react';

export default function EmailLogGrid() {
    const gridRef = useRef();
    const navigate = useNavigate();
    const { config } = useContext(ConfigContext);

    const headCells = [
        { id: 'emailTemplateId', numeric: false, disablePadding: true, label: 'Email Template ID' },
        { id: 'accepted', numeric: false, disablePadding: true, label: 'Accepted' },
        { id: 'rejected', numeric: false, disablePadding: true, label: 'Rejected' },
        { id: 'envelopeTime', numeric: true, disablePadding: true, label: 'Envelope Time' },
        { id: 'messageTime', numeric: true, disablePadding: true, label: 'Message Time' },
        { id: 'messageSize', numeric: true, disablePadding: true, label: 'Message Size' },
        { id: 'response', numeric: false, disablePadding: true, label: 'Response' },
        { id: 'createdAt', numeric: false, disablePadding: true, label: 'Created At' },
    ];

    const filterList = [
        { id: 'emailTemplateId', dataType: 'string', label: 'Email Template ID', defaultValue: '' },
        { id: 'accepted', dataType: 'string', label: 'Accepted', defaultValue: '' },
        { id: 'rejected', dataType: 'string', label: 'Rejected', defaultValue: '' },
        { id: 'envelopeTime', dataType: 'number', label: 'Envelope Time', defaultValue: '' },
        { id: 'messageTime', dataType: 'number', label: 'Message Time', defaultValue: '' },
        { id: 'messageSize', dataType: 'number', label: 'Message Size', defaultValue: '' },
        { id: 'response', dataType: 'string', label: 'Response', defaultValue: '' },
        { id: 'createdAt', dataType: 'string', label: 'Created At', defaultValue: '' },
    ];

    return (
        <div>
            <EnhancedTable
                ref={gridRef}
                tableName="Email Logs"
                searchEndpont={`${config.uri.base}/email-log`}
                actionRowClick={({ rowData }) => navigate(`/admin/email-log/${rowData._id}`)}
                actionDelete={async () => {
                    location.reload();
                }}
                headCells={headCells}
                filterList={filterList}
            />
        </div>
    );
}
